import { SMARTRR_PRODUCT_TAG } from "@smartrr/shared/constants";
import { IPurchasable } from "@smartrr/shared/entities/Purchasable";
import uniq from 'lodash/uniq';

export const removeSmartrrProductTag = (tag: string) => tag.replace(`${SMARTRR_PRODUCT_TAG}:`, "").trim();

export function getAllSmartrrFilterTags(purchasables: IPurchasable[]) {
  const allTags: string[] = [];

  for (const p of purchasables) {
    if (p.smartrrTags) {
      const tags = p.smartrrTags
        .filter(tag => tag.toLocaleLowerCase().includes(SMARTRR_PRODUCT_TAG.toLocaleLowerCase())) // additional check ensuring we're only receiving SmartrrFilter tags
        .map(removeSmartrrProductTag);
      allTags.push(...tags);
    }
  }
  return uniq(allTags);
}
